import React from 'react';
import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';

class BrandList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      setClass: props.showMenu ? 'open' : 'closed'
    };
    this.itemRefs = [];
  }

  componentDidUpdate(prevProps) {
  if (!prevProps.showMenu && this.props.showMenu) {
    requestAnimationFrame(() => {
      this.itemRefs[0]?.focus();
    });
  }
}

  componentWillReceiveProps(nextProps) {
    if (this.props.showMenu != nextProps.showMenu) {
      this.setState({
        setClass: nextProps.showMenu ? 'open' : 'closed'
      });
    }
  }

handleKeyDown = (e, index) => {
  switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      this.itemRefs[(index + 1) % this.itemRefs.length]?.focus();
      break;

    case 'ArrowUp':
      e.preventDefault();
      this.itemRefs[
        (index - 1 + this.itemRefs.length) % this.itemRefs.length
      ]?.focus();
      break;

    case 'Home':
      e.preventDefault();
      this.itemRefs[0]?.focus();
      break;

    case 'End':
      e.preventDefault();
      this.itemRefs[this.itemRefs.length - 1]?.focus();
      break;


    case 'Escape':
      this.props.closeMenu();
      break;
      
    case 'Enter':
    case ' ':
      e.preventDefault();
      this.setBrand({
        target: e.currentTarget
      });
      break;

    default:
      break;
  }
};
  setBrand = e => {
    this.setState({
      setClass: 'closed'
    });
    this.props.setBrand(e.target.id);
    this.props.returnFocusToTrigger();
  }

  render() {
    let { setClass } = this.state;
    return (
      <div className={`brands-container ${setClass}`} id="brand-menu" aria-labelledby="brandlist-menu-button">
        <p className="select-brand-txt disabled">Select a brand</p>
        <ul
         role="listbox"
          onClick={event => {
            const { code: prodCode = '', name = '' } = this.props.productData || {};
            const luxe = this.props.newDesignLuxe;
            gtmEventPush({
              event: 'size_chart_interaction',
              event_category: 'size chart interactions',
              event_action: 'brand comparision',
              event_label: `${event.target.id.split('_')[0]}`,
              page_type: 'product page',
              product_name: name,
              product_id: prodCode,
              store_type: luxe ? 'luxe' : 'ajio'
            });

            // Segment event push
            segmentEventPush({
              event: 'Size Chart Interactions',
              event_category: 'size chart interactions',
              event_action: 'brand comparision',
              event_label: `${event.target.id?.split('_')[0] || ''}`,
              // page_type: 'product page',
              inch_or_cm_flag:'',
              interaction_description: `${event.target.id?.split('_')[0] || ''}`,
              products:[{
                product_name: name,
                product_id: prodCode,
              }],            
              store_type: luxe ? 'luxe' : 'ajio',
              screen_name: 'Brand List',
              size_selected_in_radio:'',
            });
            this.setBrand(event);
          }}
        >
          {/* <li className="disabled">Select a brand</li> */}
          {this.props.brands.map((item, idx) => (
            <li
            role="option"
              key={idx}
              id={item}
              tabIndex={-1}
              ref={el => (this.itemRefs[idx] = el)}
              onKeyDown={e => this.handleKeyDown(e, idx)}
            >
              {item.split('_')[0]}
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default BrandList;
